import React from "react";
import { Link } from "react-router-dom";

const HeroServices = () => {
  return (
    // Section Container: Clean white background, top padding for sticky navbar
    <section className="pt-16 pb-20 bg-white overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Grid Layout: Text Left, Image Right */}
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-20">
          {/* --- Left Column: Text Content --- */}
          <div className="px-5 w-full lg:w-1/2 text-center lg:text-left">
            {/* Badge */}
            <span className="inline-block py-1 px-3 rounded-full bg-blue-50 text-blue-600 text-sm font-semibold mb-6 tracking-wide uppercase">
              Our Expertise
            </span>

            {/* Headline */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-slate-900 leading-tight mb-6">
              Scalable Technology <br />
              <span className="text-blue-600">Solutions for Government</span>
            </h1>

            {/* Description */}
            <p className="text-lg sm:text-xl text-slate-600 mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0">
              We specialize in building secure, high-performance digital
              infrastructures. From enterprise databases to public-facing web
              portals, we handle the complexity so you can focus on governance.
            </p>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-12">
              <Link
                to="/contact"
                className="px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg shadow-lg hover:shadow-blue-500/30 transition-all duration-300 transform hover:-translate-y-1 text-center"
              >
                Request Consultation
              </Link>
              {/* <Link
                to="#service-list"
                className="px-8 py-4 bg-slate-100 hover:bg-slate-200 text-slate-800 font-bold rounded-lg transition-all duration-300 border border-slate-200 text-center"
              >
                View All Services
              </Link> */}
            </div>

            {/* Quick Links (Popular Services) - Added for better UX */}
            <div>
              {/* <p className="text-sm font-semibold text-slate-400 mb-4 uppercase tracking-wider">
                Popular Services:
              </p> */}
              <div className="flex flex-wrap justify-center lg:justify-start gap-3">
                {[
                  "Web Development",
                  "Database Management",
                  "Mobile Applications",
                ].map((item, index) => (
                  <Link
                    key={index}
                    to="#"
                    className="px-4 py-2 bg-slate-50 text-slate-600 text-sm font-medium rounded-full border border-slate-200 hover:border-blue-600 hover:text-blue-600 transition-colors"
                  >
                    {item}
                  </Link>
                ))}
              </div>
            </div>
          </div>

          {/* --- Right Column: Image & Visuals --- */}
          <div className="w-full lg:w-1/2 relative">
            {/* Decorative Background Blob */}
            <div className="absolute -top-10 -right-10 w-72 h-72 bg-blue-50 rounded-full mix-blend-multiply filter blur-3xl opacity-70"></div>

            {/* Main Image */}
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-slate-100 group">
              <img
                src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
                alt="Team working on technical project"
                className="w-full h-auto object-cover transform group-hover:scale-105 transition-transform duration-700"
              />

              {/* Floating "Service Card" Simulation */}
              <div
                className="absolute bottom-6 left-6 right-6 sm:left-auto sm:right-6 bg-white/95 backdrop-blur-md p-5 rounded-xl shadow-xl border border-slate-100 flex items-center justify-between animate-bounce-slow"
                style={{ animationDuration: "4s" }}
              >
                <div className="flex items-center gap-4">
                  <div className="bg-blue-100 p-3 rounded-lg text-blue-600">
                    <svg
                      className="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                      ></path>
                    </svg>
                  </div>
                  <div>
                    <p className="text-xs text-slate-500 font-semibold uppercase">
                      System Status
                    </p>
                    <p className="text-sm font-bold text-slate-900">
                      All Services Operational
                    </p>
                  </div>
                </div>
                <div className="h-2 w-2 rounded-full bg-green-500 shadow-[0_0_10px_rgba(34,197,94,0.5)]"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroServices;
